import {
  Box,
  Dialog,
  Avatar,
  Tooltip,
  Typography,
  IconButton,
  DialogTitle,
  DialogContent,
} from '@mui/material';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useTranslate } from 'src/locales';
import { truncateText } from 'src/pages/chat/utils/text-formatting';

import { Iconify } from 'src/components/iconify';

import { useCallContext } from '../hooks/use-call-context';

export function CallDialog() {
  const { CallDailogMethod, incomingCall, acceptCall, rejectCall, callUserDetails } =
    useCallContext();

  const { t } = useTranslate('translation');

  const inboxView = paths.chat.root;

  const displayName =
    callUserDetails?.firstName || callUserDetails?.lastName
      ? `${callUserDetails?.firstName || ''} ${callUserDetails?.lastName || ''}`.trim()
      : callUserDetails?.phone || incomingCall?.username || 'Unknown';

  return (
    <Dialog maxWidth="xl" open={CallDailogMethod.value} onClose={CallDailogMethod.onFalse}>
      <Box sx={{ pb: 5, px: 5 }}>
        <DialogTitle sx={[(theme) => ({ p: theme.spacing(3, 3, 2, 3), textAlign: 'center' })]}>
          {`${t('INCOMING')} ${t('CALL')}`}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Avatar
              alt={callUserDetails?.firstName || callUserDetails?.lastName}
              src={
                callUserDetails?.ProfileURL || callUserDetails?.firstName || incomingCall?.username
              }
              sx={{ width: 48, height: 48 }}
            />
            <Tooltip title={displayName}>
              <Typography variant="h6" sx={{ my: 0.5 }}>
                {truncateText(displayName, 12)}
              </Typography>
            </Tooltip>

            {/* COMMENT CODE FOR THE ACCOUNT NAME FOR THE CALL */}
            {/* {callUserDetails?.company && (
              <Tooltip title={callUserDetails?.company?.name ?? ''}>
                <Typography variant="body1" color="text.secondary" sx={{ my: 0.5 }}>
                  {truncateText(callUserDetails?.company?.name, 12)}
                </Typography>
              </Tooltip>
            )} */}

            <Typography variant="body2" sx={{ color: 'text.disabled', my: 0.5 }}>
              {/* (229)538-1421 */}
              {callUserDetails?.phone || incomingCall?.number || 'N/A'}
            </Typography>
          </Box>
          <Box sx={{ height: '100px' }} />
          <Box sx={{ textAlign: 'center', my: 1 }}>
            <IconButton
              color="success"
              sx={{ bgcolor: 'success.lighter', mx: 1 }}
              component={RouterLink}
              href={inboxView}
              onClick={() => acceptCall()}
            >
              <Iconify icon="material-symbols:call" />
            </IconButton>
            <IconButton
              color="error"
              sx={{ bgcolor: 'error.lighter', mx: 1 }}
              onClick={() => rejectCall()}
            >
              <Iconify icon="solar:end-call-bold" />
            </IconButton>
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
}
